import { render, staticRenderFns } from "./EventSections.vue?vue&type=template&id=5fd05fd4&"
import script from "./EventSections.vue?vue&type=script&lang=js&"
export * from "./EventSections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports